module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_Grayzel_10.edeedb87.png";